import { SortState } from '@purespectrum1/ui/table';

import { SortParams } from '../../../shared/types/query-params';
import { SURVEY_TABLE_FIELD_TO_SORT_MAP } from './dashboard-sorting.constants';

export class DashboardSorting {
  constructor(public readonly sort: SortState) {}

  public static empty(): DashboardSorting {
    return new DashboardSorting({
      field: '',
      type: 'none',
    });
  }

  public static from(sort: SortState): DashboardSorting {
    if (!SURVEY_TABLE_FIELD_TO_SORT_MAP[sort.field]) {
      return DashboardSorting.empty();
    }

    return new DashboardSorting(sort);
  }

  public request(): SortParams {
    if (!this.sort.field || this.sort.type === 'none') {
      return {};
    }

    return {
      sortBy: SURVEY_TABLE_FIELD_TO_SORT_MAP[this.sort.field],
      sortOrder: this.sort.type === 'ascending' ? 'asc' : 'desc',
    };
  }
}
